import Vue from 'vue';
import Router from 'vue-router';
const HomeName = config.homeName;
//选择院区
import ChooseHospital from '../components/home/choose-hospital';
import home from '../components/home/home';
/**切换就诊卡页 */
import SwitchCard from '../components/addcard/switch-card';
/**添加就诊卡页 */
import AddCard from '../components/addcard/add-card';
// 挂号
import RegisterHome from '../components/register/register-home';
// 挂号搜索
import RegisterSearch from '../components/register/register-search';
// 挂号详情页
import RegisterDetail from '../components/register/register-detail';
//确定挂号
import RegisterSure from '../components/register/register-sure';
// 挂号成功
import RegisterSus from '../components/register/register-sus';
// 门诊缴费
import OutpatientHome from '../components/outpatientpay/outpatient-home';
// 门诊缴费明细
import OutpatientDeteil from '../components/outpatientpay/outpatient-deteil';
// 门诊缴费成功
import OutpatientPaysus from '../components/outpatientpay/outpatient-paysus';
//候诊信息无卡
import NoCard from '../components/waitinginfo/nocard';
//候诊信息
import WaitInformation from '../components/waitinginfo/waitinformation';

//报告查询
import RqueryHome from '../components/reportquery/query-home';
//报告查询-检验结果
import InspectionResult from '../components/reportquery/inspection-result';
//报告查询-检查报告
import CheckReport from '../components/reportquery/check-report';
//报告查询-评定报告
import EvaluationReport from '../components/reportquery/evaluation-report';

//满意度查询
import SatisfactionQuery from '../components/satisfaction/satisfaction-query';
//满意度查询-详情
import SatisfactionDeteil from '../components/satisfaction/satisfaction-deteil';

// 个人中心
import PersonalCenter from '../components/person/personal-center';
// 个人中心-挂号记录
import PersonalRecord from '../components/person/personal-record';
// 个人中心-挂号详情
import PersonalRecorddeteil from '../components/person/personal-recorddeteil';
// 个人中心-就诊记录
import PersonalMedic from '../components/person/personal-medic';
// 个人中心-就诊记录详情
import PersonalMedicdeteil from '../components/person/personal-medicdeteil';
//个人中心-缴费记录
import PersonalPayrecord from '../components/person/personal-payrecord';
//个人中心-缴费记录详情
import PersonalPayrecorddetil from '../components/person/personal-payrecorddetil';

//治疗计划
import TreatmentPlan from '../components/treatment/treatment-plan';
//治疗计划详情
import TreatmentPlandeteil from '../components/treatment/treatment-plandeteil';
//治疗计划具体类别详情
import treatmentNamedeteil from '../components/treatment/treatment-namedeteil';

//住院预交金
import IpPayment from '../components/IpPayment/IpPayment';
import IpList from '../components/IpPayment/IpList';
import IpPaymentRecord from '../components/IpPayment/IpPaymentRecord';

//错误页
import error from '../components/error/error';

//导航页面
import navigation from '../components/navigation/navigation';
//导航页面
import setmidey from '../components/setmidey/setmidey';

//xxx医院
import sectionOffice from '../components/section-office/section-office';
//xxx医院 科室名称
import officeName from '../components/section-office/office-name';
//院区详情
import hosName from '../components/section-office/hos-name'
// 待结算页面
import toPay from '../components/Pay/toPay.vue'
// 授权失败页面
import empowerOver from '../components/empowerOver/empowerOver.vue'

Vue.use(Router)

export default new Router({
  routes: [

     {
       path: '/home/choose',
       name: 'ChooseHospital',
       component: ChooseHospital,
       meta: {
        title: '选择院内'
      }
     },

    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: HomeName
      }
    },
    {
      path: '/card/switchcard',
      name: 'SwitchCard',
      component: SwitchCard,
      meta: {
        title: '切换就诊人'
      }
    },
    {
      path: '/card/addcard',
      name: 'AddCard',
      component: AddCard,
      meta: {
        title: '建档绑卡'
      }
    },
    {
      path: '/register/registerhome',
      name: 'RegisterHome',
      component: RegisterHome,
      meta: {
        title: '预约挂号'
      }
    },
    {
      path: '/register/registersearch',
      name: 'RegisterSearch',
      component: RegisterSearch,
      meta: {
        title: '搜索医生'
      }
    },
    {
      path: '/register/registerdetail/:doctorID',
      name: 'RegisterDetail',
      component: RegisterDetail,
      meta: {
        title: '挂号详情'
      }
    },
    {
      path: '/register/registersure',
      name: 'RegisterSure',
      component: RegisterSure,
      meta: {
        title: '预约挂号'
      }
    },
    {
      path: '/register/registersus',
      name: 'RegisterSus',
      component: RegisterSus,
      meta: {
        title: '预约成功'
      }
    },
    {
      path: '/pay/outpatienthome',
      name: 'OutpatientHome',
      component: OutpatientHome,
      meta: {
        title: '门诊缴费'
      }
    },
    {
      path: '/pay/outpatientdeteil/',
      name: 'OutpatientDeteil',
      component: OutpatientDeteil,
      meta: {
        title: '门诊缴费'
      }
    },
    {
      path: '/pay/outpatientpaysus/',
      name: 'OutpatientPaysus',
      component: OutpatientPaysus,
      meta: {
        title: '缴费成功'
      }
    },
    {
      path: '/waiting/nocard',
      name: 'NoCard',
      component: NoCard,
      meta: {
        title: '候诊信息'
      }
    },
    {
      path: '/waiting/waitinformation',
      name: 'WaitInformation',
      component: WaitInformation,
      meta: {
        title: '候诊信息'
      }
    },
    {
      path: '/report/query',
      name: 'RqueryHome',
      component: RqueryHome,
      meta: {
        title: '报告查询'
      }
    },
    {
      path: '/report/result',
      name: 'InspectionResult',
      component: InspectionResult,
      meta: {
        title: '检验报告'
      }
    },
    {
      path: '/report/checkreport',
      name: 'CheckReport',
      component: CheckReport,
      meta: {
        title: '检查报告'
      }
    },
    {
      path: '/report/evaluationreport',
      name: 'EvaluationReport',
      component: EvaluationReport,
      meta: {
        title: '评定报告'
      }
    },
    {
      path: '/satisfaction/query',
      name: 'SatisfactionQuery',
      component: SatisfactionQuery,
      meta: {
        title: '满意度调查'
      }
    },
    {
      path: '/satisfaction/deteil',
      name: 'SatisfactionDeteil',
      component: SatisfactionDeteil,
      meta: {
        title: '满意度调查'
      }
    },
    {
      path: '/person/center',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/person/record',
      name: 'PersonalRecord',
      component: PersonalRecord,
      meta: {
        title: '挂号记录'
      }
    },
    {
      path: '/person/deteil',
      name: 'PersonalRecorddeteil',
      component: PersonalRecorddeteil,
      meta: {
        title: '挂号详情'
      }
    },
    {
      path: '/person/medic',
      name: 'PersonalMedic',
      component: PersonalMedic,
      meta: {
        title: '就诊记录'
      }
    },
    {
      path: '/person/medicdeteil',
      name: 'PersonalMedicdeteil',
      component: PersonalMedicdeteil,
      meta: {
        title: '就诊记录详情'
      }
    },
    {
      path: '/person/paymentrecord',
      name: 'PersonalPayrecord',
      component: PersonalPayrecord,
      meta: {
        title: '缴费记录'
      }
    },
    {
      path: '/person/payrecorddetil',
      name: 'PersonalPayrecorddetil',
      component: PersonalPayrecorddetil,
      meta: {
        title: '缴费记录详情'
      }
    },
    {
      path: '/treatment/treatmentplan',
      name: 'TreatmentPlan',
      component: TreatmentPlan,
      meta: {
        title: '治疗计划'
      }
    },
    {
      path: '/treatment/plandeteil',
      name: 'TreatmentPlandeteil',
      component: TreatmentPlandeteil,
      meta: {
        title: '治疗计划详情'
      }
    },
    {
      path: '/treatment/namedeteil',
      name: 'treatmentNamedeteil',
      component: treatmentNamedeteil,
      meta: {
        title: '治疗计划'
      }
    },
    {
      path: '/IpPayment/IpPayment',
      name: 'IpPayment',
      component: IpPayment,
      meta: {
        title: '住院预交金'
      }
    },
    {
      path: '/IpPayment/IpList',
      name: 'IpList',
      component: IpList,
      meta: {
        title: '预交金查询'
      }
    },
    {
      path: '/IpPayment/IpPaymentRecord',
      name: 'IpPaymentRecord',
      component: IpPaymentRecord,
      meta: {
        title: '预交金缴费记录'
      }
    },
    {
      path: '/error',
      name: 'error',
      component: error,
      meta: {
        title: '错误'
      }
    },
    {
      path: '/navigation',
      name: 'navigation',
      component: navigation,
      meta: {
        title: '院内公众号'
      }
    },
    {
      path: '/setmidey',
      name: 'setmidey',
      component: setmidey,
      meta: {
        title: '跳转移动支付中'
      }
    },
    {
      path: '/sectionoffice',
      name: 'sectionOffice',
      component: sectionOffice,
      meta: {
        title: '科室简介'
      }
    },
    {
      path: '/officename',
      name: 'officeName',
      component: officeName,
      meta: {
        title: '科室简介'
      }
    },
    {
      path: '/hosname',
      name: 'hosName',
      component: hosName,
      meta: {
        title: '院区简介'
      }
    },
    {
      path: '/toPay',
      name: 'toPay',
      component: toPay,
      meta: {
        title: '确认支付'
      }
    },
    {
      path: '/empowerOver',
      name: 'empowerOver',
      component: empowerOver,
      meta: {
        title: '授权失败提醒'
      }
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js